export default __webpack_public_path__ + "static/media/6dots.c80976c9.svg";